<script>
	import { tooltip } from "./stores.js";

	let tt;

	$: getStyle = () => {
		if (!tt) return;
		var props = tt.getBoundingClientRect();
		let x = $tooltip.pageX - window.scrollX - props.width / 2;
		let y = $tooltip.pageY - window.scrollY + props.height;
		return `left:${x}px;top:${y}px;opacity:${$tooltip.visible ? 1 : 0}`;
	};
</script>

<style type="text/scss">

</style>

<div id="tooltip" bind:this={tt} style={getStyle()}>
	{@html $tooltip.text}
</div>
